import React from "react";
import FooterShell from "../shared/FooterShell";
import { MobileFooterVariantProps } from "../shared/types";

/** Games bar — default 6-tab footer with in-bar Games chip */
const GamesSixFooter = (props: Omit<MobileFooterVariantProps, "footerId">) => (
  <>
    <style>{`
  @media (max-width: 768px) {
    #header2 .header .mobilemenu nav ul li.game-nav::before {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        content: "";
        height: 5.366667vw;
        left: 2px;
        pointer-events: none;
        position: absolute;
        top: -5.266667vw;
        width: 100%;
        z-index: -1;
    }
}`}</style>
    <FooterShell {...props} footerId="games-six" />
  </>

);

export default GamesSixFooter;
